import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Badge } from '../ui/badge';
import { Loader2, RefreshCcw, Activity } from 'lucide-react';
import { formatCurrency } from '../../utils/formatUtils';
import { useNavigate } from 'react-router-dom';

/**
 * Gold rate management section with override capabilities
 */
export const GoldRateManagement = ({
  dashboard,
  overrideRate,
  setOverrideRate,
  overrideReason,
  setOverrideReason,
  overrideLoading,
  hasPermission,
  canEdit,
  onOverrideRate,
  onClearOverride
}) => {
  const navigate = useNavigate();
  
  return (
    <Card className="mb-6 border-gold/20">
      <CardHeader>
        <CardTitle className="font-serif text-lg text-navy flex items-center justify-between">
          <span>Gold Rate Management</span>
          {dashboard?.rate_override?.enabled && (
            <Badge className="bg-orange-100 text-orange-700">Override Active</Badge>
          )}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-6">
          <div>
            <p className="text-sm text-muted-foreground mb-2">Current 22KT Rate</p>
            <p className="font-serif text-3xl font-bold text-navy">
              {formatCurrency(dashboard?.gold_rate?.rate_22kt || 0)}
              <span className="text-sm font-normal text-muted-foreground">/gram</span>
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              Source: {dashboard?.gold_rate?.source || 'N/A'}
            </p>
            {hasPermission('settings') && (
              <Button
                size="sm"
                variant="outline"
                onClick={() => navigate('/admin/gold-rate-audit')}
                className="mt-3 border-navy/30 text-navy hover:bg-navy/5"
                data-testid="gold-rate-audit-btn"
              >
                <Activity className="w-4 h-4 mr-2" />
                View Scraping Audit
              </Button>
            )}
            {dashboard?.rate_override?.enabled && hasPermission('settings') && canEdit() && (
              <div className="mt-3 p-3 bg-orange-50 rounded-lg">
                <p className="text-sm text-orange-700">
                  <strong>Override Reason:</strong> {dashboard?.rate_override?.reason}
                </p>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={onClearOverride}
                  disabled={overrideLoading}
                  className="mt-2 border-orange-300 text-orange-700"
                >
                  {overrideLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <RefreshCcw className="w-4 h-4 mr-2" />}
                  Clear Override
                </Button>
              </div>
            )}
          </div>
          {hasPermission('settings') && canEdit() && (
            <div>
              <p className="text-sm text-muted-foreground mb-2">Manual Override</p>
              <div className="space-y-3">
                <Input
                  type="number"
                  placeholder="Enter 22KT rate (per gram)"
                  value={overrideRate}
                  onChange={(e) => setOverrideRate(e.target.value)}
                />
                <Input
                  placeholder="Reason for override"
                  value={overrideReason}
                  onChange={(e) => setOverrideReason(e.target.value)}
                />
                <Button 
                  onClick={onOverrideRate}
                  disabled={overrideLoading}
                  className="w-full gold-gradient text-navy"
                >
                  {overrideLoading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
                  Set Override Rate
                </Button>
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default GoldRateManagement;
